import { render, staticRenderFns } from "./LoadScreen.vue?vue&type=template&id=23a3141e"
import script from "./LoadScreen.vue?vue&type=script&lang=js"
export * from "./LoadScreen.vue?vue&type=script&lang=js"
import style0 from "./LoadScreen.vue?vue&type=style&index=0&id=23a3141e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.9.1_vue-template-compiler@2.7.16_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports